/**
 * Generated by orval v8.16.0 🍺
 * Do not edit manually.
 * FinPath API
 * Backend API programu FinPath (panel admina + aplikacja mobilna).
 * OpenAPI spec version: 0.1.0
 */

/**
 * * `superadmin` - Superadministrator
 * * `admin` - Administrator
 * * `teacher` - Nauczyciel
 * * `student` - Uczeń
 */
export type RoleEnum = typeof RoleEnum[keyof typeof RoleEnum];


export const RoleEnum = {
  superadmin: 'superadmin',
  admin: 'admin',
  teacher: 'teacher',
  student: 'student',
} as const;
